import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "c-pager u-mt-2xl" }
const _hoisted_2 = { class: "c-pager__wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "c-pager__separator"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.pagination.pages.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["c-pager__btn c-pager__prev", {'is-disable': $props.pagination.currentPage === 1}]),
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.prevPage && $options.prevPage(...args)))
          }, [
            _createVNode(_component_Image, { id: "arrow-left-sm" })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pagination.pages, (i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          ($options.pageToShow(i))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["c-pager__page", {'is-active': $props.pagination.currentPage == i}]),
                onClick: $event => ($props.pagination.currentPage = i)
              }, _toDisplayString(i), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
            : (!$options.pageToShow(i) && (i == 2 || i == $props.pagination.pages.length - 1))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
              : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */)),
      ($props.pagination.pages.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["c-pager__btn c-pager__next", {'is-disable': $props.pagination.currentPage === $props.pagination.pages.length}]),
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.nextPage && $options.nextPage(...args)))
          }, [
            _createVNode(_component_Image, { id: "arrow-right-sm" })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}